import { Indicator } from 'utils/models';
import { HeartRhythmMeasurementIndicatorMap } from 'models/heartRhythm/measurement';
import { IndicatorLabelContent } from './IndicatorLabelContent';

interface Props {
  indicator?: Indicator;
  label?: string;
  space?: number;
}

export const IndicatorLabel = ({ indicator, label, space = 5 }: Props) => {
  if (!indicator) return null;

  const { Icon, color } = HeartRhythmMeasurementIndicatorMap[indicator];

  const icon = Icon && <Icon color={color} />;

  return <IndicatorLabelContent icon={icon} indicator={indicator} space={space} label={label} />;
};
